import { useGetProfile } from '@/api/generated/settings/settings.ts';
import React, { useEffect, useState } from 'react';
import { type Locale, defaultLocale, t } from './i18n';

import { LanguageContext } from './language-context';

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [locale, setLocale] = useState<Locale>(defaultLocale);
  const { data: profile } = useGetProfile();

  useEffect(() => {
    if (profile?.preferences?.language) {
      setLocale(profile.preferences.language as Locale);
    }
  }, [profile?.preferences?.language]);

  const handleSetLocale = async (newLocale: Locale) => {
    setLocale(newLocale);
    // const preferences = preferencesService.getPreferencesFromStorage();//FIXME
    // if (preferences) {
    //   await preferencesService.updatePreferences({
    //     ...preferences,
    //     language: newLocale,
    //   });
    // }
  };

  return (
    <LanguageContext.Provider
      value={{
        locale,
        setLocale: handleSetLocale,
        t: (key, params) => t(key, locale, params),
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};
